import { render } from "./stock.vue?vue&type=template&id=7b597423"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__